export interface MessageCategoriesState {
    messageCategories: any[],
    messageCategoryItem?: MessageCategoryItem,
    allowedTransports: [],
    regexRulesItem: RegexRulesItem[]
}

export interface MessageCategoryFilter {
    name?: string,
    transport?: string[],
    is_default?: string[],
}

export interface MessageCategoryItem {
    id?: number
    name: string,
    transports: transports[],
    description?: string,
}

export class MessageCategoryItemImpl implements MessageCategoryItem {
    name: string;
    description: string;
    transports: transports[];

    constructor() {
        this.name = '';
        this.description = '';
        this.transports = [
            {
                transport_id: 0,
                is_default: 0,
                is_involved: 0,
            }
        ]
    }
}

export class AllowedTransports {
    transport_ids?: []
}

export class transports {
    transport_id: number | undefined;
    is_default: number;
    is_involved: number;

    constructor() {
        this.is_default = 0;
        this.is_involved = 0;
    }
}

export interface RegexRules {
    regex_rules: RegexRulesItem[]
}
export interface RegexRulesItem {
    id?: number,
    service_provider_id?: number,
    message_category_id: number,
    regex: string,
    description?: string,
    transport_id: number,
}

